import {Chacra} from './chacras.model';
import {DetailField, DetailFieldList, DetailFieldTypes, formatDate} from '../../../shared/models';

export const CHACRASDETAIL_DEFAULT_FIELDS: DetailField[] = [
  { name: 'chacraNro', label: 'Nro. de la Chacra' },
  // { name: 'chacraNombre', label: 'Nombre de la Chacra' },
  { name: 'chacraArea', label: 'Área (ha)', format: v => Math.round(v).toString() },
  // { name: 'chacraFactorAAsignado', label: 'Factor A' },
  // { name: 'chacraFactorRAsignado', label: 'Factor R' },
  // { name: 'chacraSueloAsignadoFactorK', label: 'Factor K' },
  // { name: 'chacraFactorLSAsignado', label: 'Factor LS' },
  // { name: 'chacraFactorP', label: 'Factor P' },
  // { name: 'chacraFactorAAsignado', label: 'Factor A' },
  // { name: 'chacraFactorC', label: 'Factor C' },
  // { name: 'chacraFactorLAsignado', label: 'Factor L' },
  // { name: 'chacraFactorSAsignado', label: 'Factor S' },
  // { name: 'chacraLargoAsignado', label: 'Largo (m)' },
  // { name: 'chacraPendienteAsignado', label: 'Pendiente (%)' }
];

export const CHACRASDETAIL_SUELO_FIELDS: DetailFieldList[] = [
  {
    fields: [
      { name: 'chacraSueloAsignadoDsc', label: 'Descripción' },
      { name: 'chacraSueloAsignadoFactorK', label: 'K' },
      { name: 'chacraSueloAsignadoTolerancia', label: 'T' },
      { name: 'chacraPendienteAsignado', label: 'Pendiente (%)', format: v => `${Number(v)*100}` },
      { name: 'chacraLargoAsignado', label: 'Largo Ladera (m)' }
    ]
  },
  {
    fields: [
      { name: 'formula', label: 'Formula', type: DetailFieldTypes.onlyVal },
    ]
  },
];

export interface ChacrasDetailParams {
  chacra: Chacra;
  fields?: DetailField[];
}
